import { AdminApprovalListResponseSchema, ApiKeyIdParamsSchema, ApiKeyListResponseSchema, ApprovalDecideBodySchema, ApprovalDecideResponseSchema, ApprovalGrantsListQuerySchema, ApprovalGrantsListResponseSchema, ApprovalIdParamsSchema, ApprovalListQuerySchema, ApprovalListResponseSchema, ApprovalRevokeGrantBodySchema, ApprovalRevokeGrantResponseSchema, ApprovalShowQuerySchema, ApprovalShowResponseSchema, BootstrapAdminBodySchema, BootstrapStatusResponseSchema, BudgetResponseSchema, BudgetResetResponseSchema, ChangePasswordBodySchema, CheckBatchBodySchema, CheckBatchResponseSchema, CheckBodySchema, CheckResponseSchema, ChunkBodySchema, ChunkResponseSchema, ConfirmPasswordResetBodySchema, ConfirmVerifyEmailBodySchema, ConnectorAddFolderBodySchema, McpConnectionParamsSchema, McpDiscoverResponseSchema, McpServerIdParamsSchema, McpServerListResponseSchema, McpServerSchema, McpServerWriteBodySchema, McpUserKeyBodySchema, McpUserServerListResponseSchema, ConnectorConnectionSchema, ConnectorFolderParamsSchema, ConnectorIdParamsSchema, ConnectorListResponseSchema, ConnectorSyncQueuedResponseSchema, ConsentGrantIdParamsSchema, DbConnectorActivateBodySchema, DbConnectorActivateResponseSchema, DbConnectorCreateBodySchema, DbConnectorIdParamsSchema, DbConnectorItemSchema, DbConnectorListResponseSchema, DbConnectorActiveSchemaSchema, DbConnectorSchemaResponseSchema, DbConnectorSchemaSaveBodySchema, DbConnectorSyncQueuedResponseSchema, DbConnectorTestResponseSchema, DbConnectorUpdateBodySchema, ApiKeySchema, AssignApiKeyBodySchema, CreateApiKeyBodySchema, CreateApiKeyResponseSchema, CreatePromptBodySchema, CreatePromptVersionBodySchema, CreateUserBodySchema, TrackManifestSchema, InviteUserBodySchema, TrackMeResponseSchema, TrackRoleParamsSchema, TrackRoleSchema, TrackRoleWriteBodySchema, TrackRolesListResponseSchema, UserTracksResponseSchema, DocumentDetailSchema, DocumentIdParamsSchema, DocumentPipelineSettingsSchema, DocumentListQuerySchema, DocumentListResponseSchema, DocumentRetryResponseSchema, DocumentSummaryResponseSchema, DocumentScopeBodySchema, DocumentScopeParamsSchema, DocumentsCreateQuerySchema, EmbedBodySchema, EmbedResponseSchema, GenerateBodySchema, GenerateResponseSchema, HealthResponseSchema, HubVersionResponseSchema, HubSettingEntrySchema, ExtensionListResponseSchema, ExtensionNameParamsSchema, ExtensionSettingEntrySchema, ExtensionSettingKeyParamsSchema, ExtensionSettingPutBodySchema, ExtensionSettingsListResponseSchema, HubSettingKeyParamsSchema, HubSettingPutBodySchema, HubSettingsConfigListResponseSchema, JwksResponseSchema, ListObjectsBodySchema, ListObjectsResponseSchema, ListPromptsQuerySchema, ListSessionsQuerySchema, ListSessionsResponseSchema, LlmAssignmentListResponseSchema, LlmAssignmentPurposeParamsSchema, LlmAssignmentPutBody, LlmAssignmentSchema, LlmModelCreateBody, LlmModelIdParamsSchema, LlmModelListResponseSchema, LlmModelSchema, LlmModelUpdateBody, ConnectorOauthParamsSchema, ConnectorOauthPutBody, ConnectorOauthSchema, IdentityConfigSchema, IdentityProviderListResponseSchema, IdentityProviderPutBody, OauthProviderConfigSchema, WebProviderCapabilityParamsSchema, WebProviderListResponseSchema, WebProviderPutBody, WebProviderSchema, MemoryListQuerySchema, MemoryListResponseSchema, PersonalSkillGetResponseSchema, PersonalSkillIdParamsSchema, PersonalSkillListQuerySchema, PersonalSkillListResponseSchema, PersonalSkillMineListResponseSchema, PersonalSkillMineQuerySchema, PlanDecideBodySchema, PlanDecideResponseSchema, PlanIdParamsSchema, NotificationListQuerySchema, NotificationListResponseSchema, NotificationMarkReadParamsSchema, NotificationMarkReadResponseSchema, ScheduleCreateBodySchema, ScheduleIdParamsSchema, ScheduleListQuerySchema, ScheduleListResponseSchema, SchedulePatchBodySchema, ScheduleResponseSchema, ScheduleRunsListResponseSchema, ScheduleRunsQuerySchema, ScheduleDraftResponseSchema, UpdateScheduleDraftBodySchema, DecideScheduleDraftBodySchema, DecideScheduleDraftResponseSchema, SharedSkillCreateBodySchema, SharedSkillIdParamsSchema, SharedSkillResponseSchema, SharedSkillUpdateBodySchema, MemoryIdParamsSchema, AdminUserMemoryParamsSchema, SessionSummaryResponseSchema, SsoInfoResponseSchema, LogBodySchema, AuditEventBodySchema, AuditEventListQuerySchema, AuditEventListResponseSchema, UsageSummaryQuerySchema, UsageSummaryResponseSchema, LoginBodySchema, LogoutBodySchema, LookupPromptQuerySchema, MeResponseSchema, OauthAccountsResponseSchema, OauthProviderParamsSchema, OpenIdConfigurationResponseSchema, PromptIdParamsSchema, PromptResponseSchema, PromptVersionParamsSchema, PromptVersionResponseSchema, PromptVersionsListResponseSchema, PromptWithInitialVersionSchema, PromptWithLatestVersionSchema, PromptsListResponseSchema, RefreshBodySchema, RegisterBodySchema, RelationBatchBodySchema, RelationBatchResponseSchema, RelationBodySchema, RelationListQuerySchema, RelationListResponseSchema, RelationNamespacesResponseSchema, RelationObjectsQuerySchema, RelationObjectsResponseSchema, RenderPromptBodySchema, RenderPromptResponseSchema, RequestPasswordResetBodySchema, RequestVerifyEmailBodySchema, SessionIdParamsSchema, SessionMessagesResponseSchema, SettingsBrandingResponseSchema, SearchBodySchema, SearchResponseSchema, ShareCreateResponseSchema, ShareIdParamsSchema, ShareSchema, SharesListResponseSchema, TokenPairResponseSchema, SsoReturnToQuerySchema, SsoReturnToResponseSchema, TrackIdParamsSchema, TrackResponseSchema, TracksListResponseSchema, TrackSettingParamsSchema, TrackSettingPutBodySchema, TrackSettingSchema, TrackSettingsListResponseSchema, TrackScopedCreateRelationBodySchema, TrackScopedDeleteRelationBodySchema, TrackScopedObjectParamsSchema, TrackScopedRelationsListQuerySchema, TrackScopedRelationsListResponseSchema, TrackScopedRoleSummaryResponseSchema, TrackScopedUserSearchQuerySchema, TrackScopedUserSearchResponseSchema, TrackScopedUsersListResponseSchema, UpdatePromptBodySchema, UpdateUserBodySchema, UploadResponseSchema, UpsertDefaultsBodySchema, UpsertDefaultsResponseSchema, UserIdParamsSchema, UserListResponseSchema, UserResponseSchema, WebExtractBodySchema, WebExtractResponseSchema, WebNavActBodySchema, WebNavActResponseSchema, WebNavEndBodySchema, WebNavEndResponseSchema, WebNavStartBodySchema, WebNavStartResponseSchema, WebSearchBodySchema, WebSearchResponseSchema, } from '@verybigthings/trackframe-shared/schemas';
/**
 * Single source of truth for every hub endpoint surfaced on HubClient.
 *
 * Streaming endpoints (POST /chat, POST /ai/generate with stream:true) are
 * intentionally absent — they need a dedicated streaming API surface rather
 * than a JSON-decoded Promise.
 */
export const endpoints = {
    // --- health ---
    // The bare /health endpoint is a cheap process probe used by kubelet/ALB
    // and is intentionally not exposed via the typed client. client.health()
    // hits the aggregated /health/tracks view (DB + per-track fan-out), which
    // is the shape consumers have always received here.
    health: { method: 'GET', path: '/health/tracks', response: HealthResponseSchema },
    // HUB-110 — the release the running hub was built from (signed-in callers).
    hubVersion: { method: 'GET', path: '/version', response: HubVersionResponseSchema },
    // --- auth: core (Phase 1) ---
    authRegister: {
        method: 'POST',
        path: '/auth/register',
        body: RegisterBodySchema,
        response: TokenPairResponseSchema,
    },
    authLogin: {
        method: 'POST',
        path: '/auth/login',
        body: LoginBodySchema,
        response: TokenPairResponseSchema,
    },
    authRefresh: {
        method: 'POST',
        path: '/auth/refresh',
        body: RefreshBodySchema,
        response: TokenPairResponseSchema,
    },
    authLogout: {
        method: 'POST',
        path: '/auth/logout',
        body: LogoutBodySchema,
    },
    authMe: {
        method: 'GET',
        path: '/auth/me',
        response: MeResponseSchema,
    },
    authChangePassword: {
        method: 'POST',
        path: '/auth/password/change',
        body: ChangePasswordBodySchema,
    },
    // --- auth: identity extras (Phase 3) ---
    authVerifyEmailRequest: {
        method: 'POST',
        path: '/auth/verify-email/request',
        body: RequestVerifyEmailBodySchema,
    },
    authVerifyEmailConfirm: {
        method: 'POST',
        path: '/auth/verify-email/confirm',
        body: ConfirmVerifyEmailBodySchema,
    },
    authPasswordResetRequest: {
        method: 'POST',
        path: '/auth/password-reset/request',
        body: RequestPasswordResetBodySchema,
    },
    /** Answers the login session (HUB-106 D7): setting a password from a mailed link signs the caller in. */
    authPasswordResetConfirm: {
        method: 'POST',
        path: '/auth/password-reset/confirm',
        body: ConfirmPasswordResetBodySchema,
        response: TokenPairResponseSchema,
    },
    authOauthAccounts: {
        method: 'GET',
        path: '/auth/oauth/accounts',
        response: OauthAccountsResponseSchema,
    },
    authOauthAccountUnlink: {
        method: 'DELETE',
        path: '/auth/oauth/accounts/:provider',
        params: OauthProviderParamsSchema,
    },
    // --- auth: SSO portal (cookie-backed) ---
    authSsoInfo: {
        method: 'GET',
        path: '/auth/sso/info',
        response: SsoInfoResponseSchema,
    },
    authSsoReturnTo: {
        method: 'GET',
        path: '/auth/sso/return-to',
        query: SsoReturnToQuerySchema,
        response: SsoReturnToResponseSchema,
    },
    // --- well-known (public discovery) ---
    jwks: {
        method: 'GET',
        path: '/.well-known/jwks.json',
        response: JwksResponseSchema,
    },
    openidConfiguration: {
        method: 'GET',
        path: '/.well-known/openid-configuration',
        response: OpenIdConfigurationResponseSchema,
    },
    // --- permissions (Zanzibar checks) ---
    permissionsCheck: {
        method: 'POST',
        path: '/permissions/check',
        body: CheckBodySchema,
        response: CheckResponseSchema,
    },
    permissionsCheckBatch: {
        method: 'POST',
        path: '/permissions/check-batch',
        body: CheckBatchBodySchema,
        response: CheckBatchResponseSchema,
    },
    permissionsListObjects: {
        method: 'POST',
        path: '/permissions/list-objects',
        body: ListObjectsBodySchema,
        response: ListObjectsResponseSchema,
    },
    // --- auth: bootstrap admin (Phase 5) ---
    authBootstrapAdmin: {
        method: 'POST',
        path: '/auth/bootstrap-admin',
        body: BootstrapAdminBodySchema,
        response: TokenPairResponseSchema,
    },
    authBootstrapStatus: {
        method: 'GET',
        path: '/auth/bootstrap-status',
        response: BootstrapStatusResponseSchema,
    },
    // --- relations (tuple reads/writes; admin-only) ---
    relationsList: {
        method: 'GET',
        path: '/relations',
        query: RelationListQuerySchema,
        response: RelationListResponseSchema,
    },
    relationsNamespaces: {
        method: 'GET',
        path: '/relations/namespaces',
        response: RelationNamespacesResponseSchema,
    },
    relationsObjects: {
        method: 'GET',
        path: '/relations/objects',
        query: RelationObjectsQuerySchema,
        response: RelationObjectsResponseSchema,
    },
    relationsWrite: {
        method: 'POST',
        path: '/relations',
        body: RelationBodySchema,
    },
    relationsDelete: {
        method: 'DELETE',
        path: '/relations',
        body: RelationBodySchema,
    },
    relationsBatch: {
        method: 'POST',
        path: '/relations/batch',
        body: RelationBatchBodySchema,
        response: RelationBatchResponseSchema,
    },
    // --- llm models (M27 — ADM-01/02, HUB-082; admin-only named-model registry) ---
    llmModelsList: {
        method: 'GET',
        path: '/llm-models',
        response: LlmModelListResponseSchema,
    },
    llmModelGet: {
        method: 'GET',
        path: '/llm-models/:id',
        params: LlmModelIdParamsSchema,
        response: LlmModelSchema,
    },
    llmModelCreate: {
        method: 'POST',
        path: '/llm-models',
        body: LlmModelCreateBody,
        response: LlmModelSchema,
    },
    llmModelUpdate: {
        method: 'PATCH',
        path: '/llm-models/:id',
        params: LlmModelIdParamsSchema,
        body: LlmModelUpdateBody,
        response: LlmModelSchema,
    },
    // Delete (204 on success; 409 model_assigned when bound to a purpose).
    llmModelDelete: {
        method: 'DELETE',
        path: '/llm-models/:id',
        params: LlmModelIdParamsSchema,
    },
    // --- llm assignments (M27 task-03 — ADM-03/04, HUB-082; per-purpose binding) ---
    llmAssignmentsList: {
        method: 'GET',
        path: '/llm-assignments',
        response: LlmAssignmentListResponseSchema,
    },
    llmAssignmentSet: {
        method: 'PUT',
        path: '/llm-assignments/:purpose',
        params: LlmAssignmentPurposeParamsSchema,
        body: LlmAssignmentPutBody,
        response: LlmAssignmentSchema,
    },
    // --- identity providers (M27 task-05 — ADM-07/08/18, HUB-083; DB-backed
    // login-SSO + connector OAuth config, off by default, live) ---
    identityProvidersList: {
        method: 'GET',
        path: '/identity-providers',
        response: IdentityProviderListResponseSchema,
    },
    identityProviderGet: {
        method: 'GET',
        path: '/identity-providers/:provider',
        params: OauthProviderParamsSchema,
        response: OauthProviderConfigSchema,
    },
    identityProviderPut: {
        method: 'PUT',
        path: '/identity-providers/:provider',
        params: OauthProviderParamsSchema,
        body: IdentityProviderPutBody,
        response: OauthProviderConfigSchema,
    },
    identityProviderDelete: {
        method: 'DELETE',
        path: '/identity-providers/:provider',
        params: OauthProviderParamsSchema,
    },
    connectorOauthGet: {
        method: 'GET',
        path: '/connector-oauth/:connector',
        params: ConnectorOauthParamsSchema,
        response: ConnectorOauthSchema,
    },
    connectorOauthPut: {
        method: 'PUT',
        path: '/connector-oauth/:connector',
        params: ConnectorOauthParamsSchema,
        body: ConnectorOauthPutBody,
        response: ConnectorOauthSchema,
    },
    connectorOauthDelete: {
        method: 'DELETE',
        path: '/connector-oauth/:connector',
        params: ConnectorOauthParamsSchema,
    },
    identityConfigGet: {
        method: 'GET',
        path: '/admin/identity-config',
        response: IdentityConfigSchema,
    },
    // --- web providers (M27 task-06 — ADM-15/16/17, HUB-084; DB-backed web-research
    // provider config: search/extract/nav, off by default, live) ---
    webProvidersList: {
        method: 'GET',
        path: '/web-providers',
        response: WebProviderListResponseSchema,
    },
    webProviderGet: {
        method: 'GET',
        path: '/web-providers/:capability',
        params: WebProviderCapabilityParamsSchema,
        response: WebProviderSchema,
    },
    webProviderPut: {
        method: 'PUT',
        path: '/web-providers/:capability',
        params: WebProviderCapabilityParamsSchema,
        body: WebProviderPutBody,
        response: WebProviderSchema,
    },
    webProviderDelete: {
        method: 'DELETE',
        path: '/web-providers/:capability',
        params: WebProviderCapabilityParamsSchema,
    },
    // --- objects (HUB-033 track-admin self-service tuple management) ---
    objectsRelationsList: {
        method: 'GET',
        path: '/objects/:objectType/:objectId/relations',
        params: TrackScopedObjectParamsSchema,
        query: TrackScopedRelationsListQuerySchema,
        response: TrackScopedRelationsListResponseSchema,
    },
    objectsUsersList: {
        method: 'GET',
        path: '/objects/:objectType/:objectId/users',
        params: TrackScopedObjectParamsSchema,
        response: TrackScopedUsersListResponseSchema,
    },
    objectsRoleSummary: {
        method: 'GET',
        path: '/objects/:objectType/:objectId/role-summary',
        params: TrackScopedObjectParamsSchema,
        response: TrackScopedRoleSummaryResponseSchema,
    },
    objectsRelationCreate: {
        method: 'POST',
        path: '/objects/:objectType/:objectId/relations',
        params: TrackScopedObjectParamsSchema,
        body: TrackScopedCreateRelationBodySchema,
    },
    objectsRelationDelete: {
        method: 'DELETE',
        path: '/objects/:objectType/:objectId/relations',
        params: TrackScopedObjectParamsSchema,
        body: TrackScopedDeleteRelationBodySchema,
    },
    objectsUserSearch: {
        method: 'GET',
        path: '/objects/:objectType/:objectId/user-search',
        params: TrackScopedObjectParamsSchema,
        query: TrackScopedUserSearchQuerySchema,
        response: TrackScopedUserSearchResponseSchema,
    },
    // --- api keys (admin-only, Phase 5) ---
    apiKeysCreate: {
        method: 'POST',
        path: '/api-keys',
        body: CreateApiKeyBodySchema,
        response: CreateApiKeyResponseSchema,
    },
    apiKeysList: {
        method: 'GET',
        path: '/api-keys',
        response: ApiKeyListResponseSchema,
    },
    apiKeysDelete: {
        method: 'DELETE',
        path: '/api-keys/:id',
        params: ApiKeyIdParamsSchema,
    },
    // --- users (admin-only, Phase 5) ---
    usersCreate: {
        method: 'POST',
        path: '/users',
        body: CreateUserBodySchema,
        response: UserResponseSchema,
    },
    usersList: {
        method: 'GET',
        path: '/users',
        response: UserListResponseSchema,
    },
    usersGet: {
        method: 'GET',
        path: '/users/:id',
        params: UserIdParamsSchema,
        response: UserResponseSchema,
    },
    usersUpdate: {
        method: 'PATCH',
        path: '/users/:id',
        params: UserIdParamsSchema,
        body: UpdateUserBodySchema,
        response: UserResponseSchema,
    },
    usersDisable: {
        method: 'POST',
        path: '/users/:id/disable',
        params: UserIdParamsSchema,
        response: UserResponseSchema,
    },
    usersReactivate: {
        method: 'POST',
        path: '/users/:id/reactivate',
        params: UserIdParamsSchema,
        response: UserResponseSchema,
    },
    /**
     * HUB-106: send (or re-send) a set-password invite link. 204; 409 once the
     * user is active. HUB-109 D7: `body` may carry `{ trackId, level?, roleIds }`
     * — the grant is written before the mail; `{}` is the plain invite.
     */
    usersInvite: {
        method: 'POST',
        path: '/users/:id/invite',
        params: UserIdParamsSchema,
        body: InviteUserBodySchema,
    },
    /** HUB-109 D7: every track the user enters by level or role (admin-only). */
    usersTracksList: {
        method: 'GET',
        path: '/users/:id/tracks',
        params: UserIdParamsSchema,
        response: UserTracksResponseSchema,
    },
    // --- tracks (HUB-062 / DEV-014) ---
    // Tracks register themselves via an idempotent manifest upsert. The body
    // is the resolved TrackManifest (track-provided UUID, slug, env-resolved
    // URLs, inline OpenAPI, inline systemPrompt). POST/PATCH/refresh-spec were
    // removed alongside the hub→track URL fetch (issue #145).
    tracksUpsert: {
        method: 'PUT',
        path: '/tracks/:id',
        params: TrackIdParamsSchema,
        body: TrackManifestSchema,
        response: TrackResponseSchema,
    },
    tracksList: {
        method: 'GET',
        path: '/tracks',
        response: TracksListResponseSchema,
    },
    tracksGet: {
        method: 'GET',
        path: '/tracks/:id',
        params: TrackIdParamsSchema,
        response: TrackResponseSchema,
    },
    tracksDelete: {
        method: 'DELETE',
        path: '/tracks/:id',
        params: TrackIdParamsSchema,
    },
    // --- track roles (HUB-109 D4 / D6) ---
    /** The track's roles AND its permission catalog; system admin or `track#admin`. */
    tracksRolesList: {
        method: 'GET',
        path: '/tracks/:id/roles',
        params: TrackIdParamsSchema,
        response: TrackRolesListResponseSchema,
    },
    tracksRoleCreate: {
        method: 'POST',
        path: '/tracks/:id/roles',
        params: TrackIdParamsSchema,
        body: TrackRoleWriteBodySchema,
        response: TrackRoleSchema,
    },
    /** Rename + FULL replacement of the role's permissions. */
    tracksRoleUpdate: {
        method: 'PATCH',
        path: '/tracks/:id/roles/:roleId',
        params: TrackRoleParamsSchema,
        body: TrackRoleWriteBodySchema,
        response: TrackRoleSchema,
    },
    tracksRoleDelete: {
        method: 'DELETE',
        path: '/tracks/:id/roles/:roleId',
        params: TrackRoleParamsSchema,
    },
    /** D6: the signed-in user's level, roles and manifest permissions — never the JWT. */
    tracksMe: {
        method: 'GET',
        path: '/tracks/:id/me',
        params: TrackIdParamsSchema,
        response: TrackMeResponseSchema,
    },
    tracksGetBudget: {
        method: 'GET',
        path: '/tracks/:id/budget',
        params: TrackIdParamsSchema,
        response: BudgetResponseSchema,
    },
    tracksSettingsList: {
        method: 'GET',
        path: '/tracks/:id/settings',
        params: TrackIdParamsSchema,
        response: TrackSettingsListResponseSchema,
    },
    tracksSettingsGet: {
        method: 'GET',
        path: '/tracks/:id/settings/:key',
        params: TrackSettingParamsSchema,
        response: TrackSettingSchema,
    },
    tracksSettingsPut: {
        method: 'PUT',
        path: '/tracks/:id/settings/:key',
        params: TrackSettingParamsSchema,
        body: TrackSettingPutBodySchema,
        response: TrackSettingSchema,
    },
    tracksSettingsDelete: {
        method: 'DELETE',
        path: '/tracks/:id/settings/:key',
        params: TrackSettingParamsSchema,
    },
    tracksBudgetReset: {
        method: 'POST',
        path: '/tracks/:id/budget/reset',
        params: TrackIdParamsSchema,
        response: BudgetResetResponseSchema,
    },
    // Track ↔ API-key binding (HUB-089): assign an existing unbound machine key
    // to a track, or rotate (revoke + mint-and-bind, plaintext returned once).
    tracksApiKeyAssign: {
        method: 'POST',
        path: '/tracks/:id/api-key/assign',
        params: TrackIdParamsSchema,
        body: AssignApiKeyBodySchema,
        response: ApiKeySchema,
    },
    tracksApiKeyRotate: {
        method: 'POST',
        path: '/tracks/:id/api-key/rotate',
        params: TrackIdParamsSchema,
        response: CreateApiKeyResponseSchema,
    },
    // --- sessions ---
    sessionsList: {
        method: 'GET',
        path: '/sessions',
        query: ListSessionsQuerySchema,
        response: ListSessionsResponseSchema,
    },
    sessionsMessages: {
        method: 'GET',
        path: '/sessions/:id/messages',
        params: SessionIdParamsSchema,
        response: SessionMessagesResponseSchema,
    },
    sessionsDelete: {
        method: 'DELETE',
        path: '/sessions/:id',
        params: SessionIdParamsSchema,
    },
    // --- memory (MEM-10, COP-032; in-stream writes go via /chat per D-13) ---
    memoryList: {
        method: 'GET',
        path: '/memory',
        query: MemoryListQuerySchema,
        response: MemoryListResponseSchema,
    },
    memoryDelete: {
        method: 'DELETE',
        path: '/memory/:id',
        params: MemoryIdParamsSchema,
    },
    // Permanent wipe (IMEM-20, COP-105): the deliberate owner-only hard delete,
    // distinct from the soft-delete above. Backs the "Delete permanently" action
    // in the admin per-user Memory tab; RLS keeps it self-only server-side.
    memoryDeletePermanent: {
        method: 'DELETE',
        path: '/memory/:id/permanent',
        params: MemoryIdParamsSchema,
    },
    // Admin-only per-user memory listing (D-20). Backs the per-user Memory tab in
    // the admin SPA (plan-9). Hub-side authz: requireAdmin gate inside users.ts;
    // data read still wraps withUserRole(targetUserId) so RLS validates the
    // target user's role (HUB-024 §6, D-09).
    adminListMemory: {
        method: 'GET',
        path: '/users/:id/memory',
        params: AdminUserMemoryParamsSchema,
        query: MemoryListQuerySchema,
        response: MemoryListResponseSchema,
    },
    // Session-summary lives under /sessions/ for affinity with existing routes
    // (MEM-11, COP-033).
    sessionsSummary: {
        method: 'GET',
        path: '/sessions/:id/summary',
        params: SessionIdParamsSchema,
        response: SessionSummaryResponseSchema,
    },
    sessionsSummaryDelete: {
        method: 'DELETE',
        path: '/sessions/:id/summary',
        params: SessionIdParamsSchema,
    },
    // --- personal skills (COP-064, COP-067) ---
    // Normal users can list/view/delete their own current-track user_track skills.
    // Direct create/update is intentionally absent; personal writes flow through
    // exact-payload skill-suggestion approvals so the previewed markdown is the
    // markdown that gets saved.
    skillsList: {
        method: 'GET',
        path: '/skills',
        query: PersonalSkillListQuerySchema,
        response: PersonalSkillListResponseSchema,
    },
    // Session-derived list for the Copilot-widget skills-management dropdown. The
    // widget has no ambient trackId; the hub derives the track from the session
    // (mirrors approvalsListGrants). Returns only the caller's own user_track skills.
    skillsListMine: {
        method: 'GET',
        path: '/skills/mine',
        query: PersonalSkillMineQuerySchema,
        response: PersonalSkillMineListResponseSchema,
    },
    skillsGet: {
        method: 'GET',
        path: '/skills/:id',
        params: PersonalSkillIdParamsSchema,
        response: PersonalSkillGetResponseSchema,
    },
    // Admins can curate shared deployment/track skills directly. Normal-user
    // personal `user_track` create/update remains approval-bound and is not
    // represented by these schemas (COP-067).
    skillsCreate: {
        method: 'POST',
        path: '/skills',
        body: SharedSkillCreateBodySchema,
        response: SharedSkillResponseSchema,
    },
    skillsUpdate: {
        method: 'PATCH',
        path: '/skills/:id',
        params: SharedSkillIdParamsSchema,
        body: SharedSkillUpdateBodySchema,
        response: SharedSkillResponseSchema,
    },
    skillsDelete: {
        method: 'DELETE',
        path: '/skills/:id',
        params: PersonalSkillIdParamsSchema,
    },
    // --- approvals (APPR-05, APPR-06, APPR-07 — COP-010, COP-011, COP-013, COP-023) ---
    /** APPR-05, APPR-06 — D-01 hash-bound decide + D-13 continuation-turn entry (COP-010, COP-011). */
    approvalsDecide: {
        method: 'POST',
        path: '/approvals/:id/decide',
        params: ApprovalIdParamsSchema,
        body: ApprovalDecideBodySchema,
        response: ApprovalDecideResponseSchema,
    },
    /**
     * COP-093 §Revocation — revoke the caller's active `always` consent grant for
     * `(trackId, toolName)`. Drives the inline "you always allow this — Undo"
     * control on the per-step consent card. Idempotent.
     */
    approvalsRevokeGrant: {
        method: 'POST',
        path: '/approvals/revoke-grant',
        body: ApprovalRevokeGrantBodySchema,
        response: ApprovalRevokeGrantResponseSchema,
    },
    /**
     * COP-094 (APPR-10, UI-06) — list the caller's active standing consent grants
     * for the widget management dropdown. Supplies only `sessionId`; the hub
     * derives the track from the session and lists `always` (that track) +
     * `session` (that session, `plan_id IS NULL`) grants.
     */
    approvalsListGrants: {
        method: 'GET',
        path: '/approvals/grants',
        query: ApprovalGrantsListQuerySchema,
        response: ApprovalGrantsListResponseSchema,
    },
    /**
     * COP-094 (APPR-10, UI-06) — revoke a single standing grant by id, the
     * dropdown's per-row Revoke action. RLS-owner-scoped, idempotent.
     */
    approvalsRevokeGrantById: {
        method: 'POST',
        path: '/approvals/grants/:id/revoke',
        params: ConsentGrantIdParamsSchema,
        response: ApprovalRevokeGrantResponseSchema,
    },
    /** APPR-06 — user-scoped approvals list; Hub route wraps withUserRole for RLS (COP-010). */
    approvalsList: {
        method: 'GET',
        path: '/approvals',
        query: ApprovalListQuerySchema,
        response: ApprovalListResponseSchema,
    },
    /**
     * APPR-07 — admin approvals list; Hub route enforces requireAdmin (COP-024).
     *
     * Response is `AdminApprovalListResponseSchema` — COP-148 D8 puts
     * `executionStatus` / `executionError` on THIS surface only, so the admin SPA
     * types resolve them while `approvalsList` above stays clean (COP-134).
     */
    adminListApprovals: {
        method: 'GET',
        path: '/admin/approvals',
        query: ApprovalListQuerySchema,
        response: AdminApprovalListResponseSchema,
    },
    /**
     * APPR-07 — admin approval show, returns row + D-15 decisions[] audit trail (COP-013, COP-024).
     *
     * Requires `userId` query param: Plan 05-08's `/admin/approvals/:id` route
     * scopes the read inside `withUserRole(targetUserId, …)` (HUB-024 §6) and the
     * adapter asserts `row.userId === userId` as defense-in-depth. The admin SPA
     * (Plan 05-12) forwards `row.userId` from the list response to the Show
     * click-through URL — see `packages/hub/admin/src/pages/approvals/List.tsx`.
     */
    adminGetApproval: {
        method: 'GET',
        path: '/admin/approvals/:id',
        params: ApprovalIdParamsSchema,
        query: ApprovalShowQuerySchema,
        response: ApprovalShowResponseSchema,
    },
    // --- plans (COP-071, COP-073 — Hub-owned plan lifecycle; execution comes later) ---
    /** Hash-bound user decision for a pending plan card. */
    plansDecide: {
        method: 'POST',
        path: '/plans/:id/decide',
        params: PlanIdParamsSchema,
        body: PlanDecideBodySchema,
        response: PlanDecideResponseSchema,
    },
    // --- schedules (COP-074, COP-076, COP-077 — Hub-owned scheduled actions) ---
    /** Create an owner-scoped scheduled action. Optional Idempotency-Key makes browser retries safe. */
    schedulesCreate: {
        method: 'POST',
        path: '/schedules',
        body: ScheduleCreateBodySchema,
        idempotencyKey: true,
        response: ScheduleResponseSchema,
    },
    /** List the caller's own schedules. Admin/operator listing must be an explicit separate surface. */
    schedulesList: {
        method: 'GET',
        path: '/schedules',
        query: ScheduleListQuerySchema,
        response: ScheduleListResponseSchema,
    },
    /** Fetch one caller-owned schedule with latest redacted run summary. */
    schedulesGet: {
        method: 'GET',
        path: '/schedules/:id',
        params: ScheduleIdParamsSchema,
        response: ScheduleResponseSchema,
    },
    /** Optimistic-concurrency update for owner-scoped schedule state. */
    schedulesUpdate: {
        method: 'PATCH',
        path: '/schedules/:id',
        params: ScheduleIdParamsSchema,
        body: SchedulePatchBodySchema,
        idempotencyKey: true,
        response: ScheduleResponseSchema,
    },
    /** Soft-delete a caller-owned schedule. */
    schedulesDelete: {
        method: 'DELETE',
        path: '/schedules/:id',
        params: ScheduleIdParamsSchema,
    },
    /** List redacted run history for a caller-owned schedule. Defaults are enforced by the Hub route. */
    schedulesRuns: {
        method: 'GET',
        path: '/schedules/:id/runs',
        params: ScheduleIdParamsSchema,
        query: ScheduleRunsQuerySchema,
        response: ScheduleRunsListResponseSchema,
    },
    // --- schedule drafts (SCUX-04 / SCUX-05 — chat-created schedule consent seam, Plan 02-04) ---
    /**
     * D-18 — hash-bound PATCH of a pending chat-created schedule draft. The
     * caller MUST send the prior `payloadHash`; mismatch returns 409
     * `preview_stale`. On success the response carries the regenerated hash
     * and refreshed `expiresAt`.
     *
     * Response shape is route-local (the hub returns
     * `{ id, payloadHash, expiresAt, payload }`) and is not bound to a shared
     * TypeBox response schema here because Plan 02-01 did not surface one;
     * Plan 02-06's `SchedulePreviewCard` consumer narrows to the route-known
     * field set on read.
     */
    scheduleDraftsPatch: {
        method: 'PATCH',
        path: '/schedule-drafts/:id',
        params: ScheduleIdParamsSchema,
        body: UpdateScheduleDraftBodySchema,
        // Response MUST be declared — `HubClient._call` returns undefined when
        // `def.response === undefined`, which would make the
        // `SchedulePreviewCard`'s `setPayloadHash(response.payloadHash)` after
        // PATCH a silent no-op and the next Approve trip `preview_stale`
        // (P-41.5 root cause).
        response: ScheduleDraftResponseSchema,
    },
    /**
     * Stale-hash recovery seam (Gap 2 / CR-03). Returns the current owned
     * pending draft so the SchedulePreviewCard can refresh its local payloadHash
     * after a 409 preview_stale. Owner isolation enforced by RLS; no session
     * scoping. Terminal / expired drafts resolve as 404.
     */
    scheduleDraftsGet: {
        method: 'GET',
        path: '/schedule-drafts/:id',
        params: ScheduleIdParamsSchema,
        response: ScheduleDraftResponseSchema,
    },
    /**
     * D-19 — idempotent approve / reject of a pending chat-created schedule
     * draft. Response is `DecideScheduleDraftResponseSchema` (status discriminator
     * plus the persisted scheduleId echo on approve).
     */
    scheduleDraftsDecide: {
        method: 'POST',
        path: '/schedule-drafts/:id/decide',
        params: ScheduleIdParamsSchema,
        body: DecideScheduleDraftBodySchema,
        response: DecideScheduleDraftResponseSchema,
    },
    // --- notifications (COP-075 / HUB-024 — owner-scoped scheduled action outcomes) ---
    /** List caller-owned scheduler notifications. Admin/operator browsing must be a separate surface. */
    notificationsList: {
        method: 'GET',
        path: '/notifications',
        query: NotificationListQuerySchema,
        response: NotificationListResponseSchema,
    },
    /** Mark a caller-owned scheduler notification as read. Cross-owner rows resolve as 404. */
    notificationsMarkRead: {
        method: 'PATCH',
        path: '/notifications/:id/read',
        params: NotificationMarkReadParamsSchema,
        response: NotificationMarkReadResponseSchema,
    },
    // --- prompts ---
    promptsCreate: {
        method: 'POST',
        path: '/prompts',
        body: CreatePromptBodySchema,
        response: PromptWithInitialVersionSchema,
    },
    promptsList: {
        method: 'GET',
        path: '/prompts',
        query: ListPromptsQuerySchema,
        response: PromptsListResponseSchema,
    },
    promptsLookup: {
        method: 'GET',
        path: '/prompts/lookup',
        query: LookupPromptQuerySchema,
        response: PromptWithLatestVersionSchema,
    },
    promptsUpsertDefaults: {
        method: 'POST',
        path: '/prompts/upsert-defaults',
        body: UpsertDefaultsBodySchema,
        response: UpsertDefaultsResponseSchema,
    },
    promptsGet: {
        method: 'GET',
        path: '/prompts/:id',
        params: PromptIdParamsSchema,
        response: PromptWithLatestVersionSchema,
    },
    promptsUpdate: {
        method: 'PATCH',
        path: '/prompts/:id',
        params: PromptIdParamsSchema,
        body: UpdatePromptBodySchema,
        response: PromptResponseSchema,
    },
    promptsDelete: {
        method: 'DELETE',
        path: '/prompts/:id',
        params: PromptIdParamsSchema,
    },
    promptsCreateVersion: {
        method: 'POST',
        path: '/prompts/:id/versions',
        params: PromptIdParamsSchema,
        body: CreatePromptVersionBodySchema,
        response: PromptVersionResponseSchema,
    },
    promptsVersions: {
        method: 'GET',
        path: '/prompts/:id/versions',
        params: PromptIdParamsSchema,
        response: PromptVersionsListResponseSchema,
    },
    promptsGetVersion: {
        method: 'GET',
        path: '/prompts/:id/versions/:version',
        params: PromptVersionParamsSchema,
        response: PromptVersionResponseSchema,
    },
    promptsRender: {
        method: 'POST',
        path: '/prompts/:id/render',
        params: PromptIdParamsSchema,
        body: RenderPromptBodySchema,
        response: RenderPromptResponseSchema,
    },
    // --- ai ---
    aiGenerate: {
        method: 'POST',
        path: '/ai/generate',
        body: GenerateBodySchema,
        response: GenerateResponseSchema,
    },
    aiEmbed: {
        method: 'POST',
        path: '/ai/embed',
        body: EmbedBodySchema,
        response: EmbedResponseSchema,
    },
    aiChunk: {
        method: 'POST',
        path: '/ai/chunk',
        body: ChunkBodySchema,
        response: ChunkResponseSchema,
    },
    // --- document ingestion + search (HUB-048..HUB-054) ---
    // Track-agnostic bucket upload (HUB-076, DND-01/02 — owner-only, user
    // principals only). The ONE upload endpoint since milestone-32 task-09
    // (DMET-07) deleted the estimate-scoped `documentsUpload` with its route.
    // `bodyKind:'multipart'`
    // makes the typed method accept a pass-through `FormData` body and makes
    // `_call` forward it to `fetch` untouched so the runtime sets the multipart
    // boundary. The hub route reads the FIRST file part via `request.file()`
    // (packages/hub/src/routes/documents.ts), so the multipart field name is NOT
    // enforced — send a single file part (conventionally `file`); the filename +
    // MIME type come from that part. No JSON `body` schema applies here. Bucket
    // selection rides the QUERYSTRING: `trackId` OR `trackName` → track bucket
    // (both → 400); neither → global bucket.
    documentsCreate: {
        method: 'POST',
        path: '/documents',
        query: DocumentsCreateQuerySchema,
        bodyKind: 'multipart',
        response: UploadResponseSchema,
    },
    // ADM-12 (COP-117): the collection route — every document the caller can read
    // (own ∪ shared; admins get all via the system#admin short-circuit),
    // filterable by status/track/owner and paginated. LIGHT items (no
    // extractedText). Auth-only, not admin-gated.
    documentsList: {
        method: 'GET',
        path: '/documents',
        query: DocumentListQuerySchema,
        response: DocumentListResponseSchema,
    },
    // ADM-12: response widened to the extended detail (summary + readiness +
    // tuple-derived access summary) — still the single per-id `read`-gated route.
    documentsGet: {
        method: 'GET',
        path: '/documents/:id',
        params: DocumentIdParamsSchema,
        response: DocumentDetailSchema,
    },
    // HUB-086: original stored bytes (never extracted text). Binary response —
    // resolves { bytes, contentType }; non-oracle 404 for missing AND unreadable.
    documentsGetContent: {
        method: 'GET',
        path: '/documents/:id/content',
        params: DocumentIdParamsSchema,
        responseKind: 'binary',
    },
    documentsDelete: {
        method: 'DELETE',
        path: '/documents/:id',
        params: DocumentIdParamsSchema,
    },
    documentsRetry: {
        method: 'POST',
        path: '/documents/:id/retry',
        params: DocumentIdParamsSchema,
        response: DocumentRetryResponseSchema,
    },
    // ADM-14 (COP-117): manual summary regenerate (owner/admin). 502 on a
    // generation failure; the row is written only on success.
    documentsGenerateSummary: {
        method: 'POST',
        path: '/documents/:id/summary',
        params: DocumentIdParamsSchema,
        response: DocumentSummaryResponseSchema,
    },
    documentsSharesList: {
        method: 'GET',
        path: '/documents/:id/shares',
        params: DocumentIdParamsSchema,
        response: SharesListResponseSchema,
    },
    documentsSharesCreate: {
        method: 'POST',
        path: '/documents/:id/shares',
        params: DocumentIdParamsSchema,
        body: ShareSchema,
        response: ShareCreateResponseSchema,
    },
    documentsSharesDelete: {
        method: 'DELETE',
        path: '/documents/:id/shares/:shareId',
        params: ShareIdParamsSchema,
    },
    // Canonical owner-only broad-scope set (IMEM-09 / HUB-065). 204 No Content.
    documentsSetScope: {
        method: 'PUT',
        path: '/documents/:id/scope',
        params: DocumentScopeParamsSchema,
        body: DocumentScopeBodySchema,
    },
    // ADM-13 (COP-117, INV-01): hybrid search over EVERY document the caller can
    // read (cross-track ∪ global). Auth-only — the per-doc `read` loop scopes it.
    documentsSearch: {
        method: 'POST',
        path: '/documents/search',
        body: SearchBodySchema,
        response: SearchResponseSchema,
    },
    // ADM-06 (COP-117): read-only RAG pipeline settings (requireAdmin).
    documentsPipelineSettings: {
        method: 'GET',
        path: '/documents/pipeline-settings',
        response: DocumentPipelineSettingsSchema,
    },
    // --- connectors (M16 — HUB-074/HUB-075; CONN-01/02/07) ---
    // The consent-flow /connectors/google-drive/start + /callback routes are
    // browser redirects and are intentionally NOT declared here (the
    // auth-oauth precedent). Disconnect wipes the tokens AND every synced doc.
    connectorsList: {
        method: 'GET',
        path: '/connectors',
        response: ConnectorListResponseSchema,
    },
    connectorsDelete: {
        method: 'DELETE',
        path: '/connectors/:id',
        params: ConnectorIdParamsSchema,
    },
    // Designate a folder by pasted Drive link/ID, validated against Drive
    // (CONN-03; HUB-075 §2). 200 = the updated connection shape.
    connectorsAddFolder: {
        method: 'POST',
        path: '/connectors/:id/folders',
        params: ConnectorIdParamsSchema,
        body: ConnectorAddFolderBodySchema,
        response: ConnectorConnectionSchema,
    },
    // Undesignate a folder (204). The folder's docs are cleaned up by the NEXT
    // sync pass's presence diff — never inline here (HUB-075 §3).
    connectorsRemoveFolder: {
        method: 'DELETE',
        path: '/connectors/:id/folders/:folderId',
        params: ConnectorFolderParamsSchema,
    },
    // Sync now — flags the connection and kicks a tick; never awaits the sync
    // (CONN-07; HUB-075 §3). 202 { status: 'queued' }.
    connectorsSyncNow: {
        method: 'POST',
        path: '/connectors/:id/sync',
        params: ConnectorIdParamsSchema,
        response: ConnectorSyncQueuedResponseSchema,
    },
    // --- MCP servers (HUB-107 / COP-152) ---
    // Admin registry (system admin). Secrets are write-only; responses carry
    // presence flags only. `mcpServerDiscover` lists the live tools with the
    // admin's OWN credential, marked approved/changed against the allowlist.
    mcpServersList: {
        method: 'GET',
        path: '/mcp-servers',
        response: McpServerListResponseSchema,
    },
    mcpServerCreate: {
        method: 'POST',
        path: '/mcp-servers',
        body: McpServerWriteBodySchema,
        response: McpServerSchema,
    },
    mcpServerUpdate: {
        method: 'PUT',
        path: '/mcp-servers/:id',
        params: McpServerIdParamsSchema,
        body: McpServerWriteBodySchema,
        response: McpServerSchema,
    },
    mcpServerDelete: {
        method: 'DELETE',
        path: '/mcp-servers/:id',
        params: McpServerIdParamsSchema,
    },
    mcpServerDiscover: {
        method: 'POST',
        path: '/mcp-servers/:id/discover',
        params: McpServerIdParamsSchema,
        response: McpDiscoverResponseSchema,
    },
    // The caller's OWN connections. The OAuth /start + /callback routes are
    // browser redirects and are intentionally NOT declared here (the connectors
    // precedent above).
    mcpConnectionsList: {
        method: 'GET',
        path: '/mcp-connections',
        response: McpUserServerListResponseSchema,
    },
    mcpConnectionSetKey: {
        method: 'PUT',
        path: '/mcp-connections/:serverId/key',
        params: McpConnectionParamsSchema,
        body: McpUserKeyBodySchema,
    },
    mcpConnectionDelete: {
        method: 'DELETE',
        path: '/mcp-connections/:serverId',
        params: McpConnectionParamsSchema,
    },
    // --- db-connectors (M24 task-05; HUB-079 §5) ---
    // Admin CRUD + schema editor. Registered on the hub only when
    // `config.dbConnectors` is set. Responses never carry connection-string
    // material.
    dbConnectorsList: {
        method: 'GET',
        path: '/db-connectors',
        response: DbConnectorListResponseSchema,
    },
    dbConnectorsCreate: {
        method: 'POST',
        path: '/db-connectors',
        body: DbConnectorCreateBodySchema,
        response: DbConnectorItemSchema,
    },
    dbConnectorsTest: {
        method: 'POST',
        path: '/db-connectors/:id/test',
        params: DbConnectorIdParamsSchema,
        response: DbConnectorTestResponseSchema,
    },
    // Sync now — flags the connector and kicks a tick; never awaits the sync.
    // 202 { queued: true }.
    dbConnectorsSync: {
        method: 'POST',
        path: '/db-connectors/:id/sync',
        params: DbConnectorIdParamsSchema,
        response: DbConnectorSyncQueuedResponseSchema,
    },
    dbConnectorsSchema: {
        method: 'GET',
        path: '/db-connectors/:id/schema',
        params: DbConnectorIdParamsSchema,
        response: DbConnectorSchemaResponseSchema,
    },
    dbConnectorsSchemaSave: {
        method: 'PUT',
        path: '/db-connectors/:id/schema',
        params: DbConnectorIdParamsSchema,
        body: DbConnectorSchemaSaveBodySchema,
        response: DbConnectorActiveSchemaSchema,
    },
    dbConnectorsSchemaActivate: {
        method: 'POST',
        path: '/db-connectors/:id/schema/activate',
        params: DbConnectorIdParamsSchema,
        body: DbConnectorActivateBodySchema,
        response: DbConnectorActivateResponseSchema,
    },
    dbConnectorsUpdate: {
        method: 'PATCH',
        path: '/db-connectors/:id',
        params: DbConnectorIdParamsSchema,
        body: DbConnectorUpdateBodySchema,
        response: DbConnectorItemSchema,
    },
    // Delete (204): row + schema versions (FK cascade) + tuples + cached executor.
    dbConnectorsDelete: {
        method: 'DELETE',
        path: '/db-connectors/:id',
        params: DbConnectorIdParamsSchema,
    },
    // --- web research (M26 — HUB-081; WEB-02/05/07) ---
    // trackId-gated + budget-metered; the server-to-server surface custom
    // workflows (Estimates) call. webExtract persists via the task-05 pipeline and
    // returns a locator, not the page body.
    webSearch: {
        method: 'POST',
        path: '/web/search',
        body: WebSearchBodySchema,
        response: WebSearchResponseSchema,
    },
    webExtract: {
        method: 'POST',
        path: '/web/extract',
        body: WebExtractBodySchema,
        response: WebExtractResponseSchema,
    },
    // --- web navigation (M26 task-07 — HUB-081; WEB-01/04/10) ---
    // Session-oriented live browse over tf_web_session. The Copilot nav tools
    // (task-09) drive these from the browser, so all three are in
    // COPILOT_CALL_ALLOWLIST. start opens a session, act runs one primitive
    // (navigate/click/type/read) against the persisted handle, end closes it.
    webNavStart: {
        method: 'POST',
        path: '/web/nav/start',
        body: WebNavStartBodySchema,
        response: WebNavStartResponseSchema,
    },
    webNavAct: {
        method: 'POST',
        path: '/web/nav/act',
        body: WebNavActBodySchema,
        response: WebNavActResponseSchema,
    },
    webNavEnd: {
        method: 'POST',
        path: '/web/nav/end',
        body: WebNavEndBodySchema,
        response: WebNavEndResponseSchema,
    },
    // --- telemetry ---
    telemetryLog: {
        method: 'POST',
        path: '/telemetry/log',
        body: LogBodySchema,
    },
    // --- audit log ---
    // Write: report a consequential action (the track's API key is the verified
    // provenance; the human actor is asserted in the body). Fire-and-forget (204).
    recordAuditEvent: {
        method: 'POST',
        path: '/audit/events',
        body: AuditEventBodySchema,
    },
    // Read: caller sees their own actions unless they hold audit_log:global#viewer.
    auditEventList: {
        method: 'GET',
        path: '/audit/events',
        query: AuditEventListQuerySchema,
        response: AuditEventListResponseSchema,
    },
    // --- adoption / usage (ATRU-06; COP-134 D4) ---
    // Admin-gated counts aggregated from tf_audit_event — per-track, per-user or
    // per-route inside a half-open [from, to) window. Never proxied to the
    // browser Copilot: this is an admin surface.
    usageSummary: {
        method: 'GET',
        path: '/usage/summary',
        query: UsageSummaryQuerySchema,
        response: UsageSummaryResponseSchema,
    },
    // --- settings (hub-wide branding; reachable via the typed client and via
    // hub-proxy /call so track frontends can mount the shared header without
    // additional plumbing) ---
    settingsBranding: {
        method: 'GET',
        path: '/settings/branding',
        response: SettingsBrandingResponseSchema,
    },
    // Admin-gated hub settings registry (HUB-092 §5; M31 task-10). Secret keys
    // never carry `value` over the wire — `hasValue` is the presence marker.
    settingsConfigList: {
        method: 'GET',
        path: '/settings/config',
        response: HubSettingsConfigListResponseSchema,
    },
    settingsConfigPut: {
        method: 'PUT',
        path: '/settings/config/:key',
        params: HubSettingKeyParamsSchema,
        body: HubSettingPutBodySchema,
        response: HubSettingEntrySchema,
    },
    settingsConfigDelete: {
        method: 'DELETE',
        path: '/settings/config/:key',
        params: HubSettingKeyParamsSchema,
    },
    // Enabled hub extensions + their declared settings (HUB-099 / HUB-103;
    // admin-gated). Secret keys never carry `value` — `hasValue` is the marker.
    extensionsList: {
        method: 'GET',
        path: '/extensions',
        response: ExtensionListResponseSchema,
    },
    extensionSettingsList: {
        method: 'GET',
        path: '/extensions/:name/settings',
        params: ExtensionNameParamsSchema,
        response: ExtensionSettingsListResponseSchema,
    },
    extensionSettingsPut: {
        method: 'PUT',
        path: '/extensions/:name/settings/:key',
        params: ExtensionSettingKeyParamsSchema,
        body: ExtensionSettingPutBodySchema,
        response: ExtensionSettingEntrySchema,
    },
    extensionSettingsDelete: {
        method: 'DELETE',
        path: '/extensions/:name/settings/:key',
        params: ExtensionSettingKeyParamsSchema,
    },
};
//# sourceMappingURL=endpoints.js.map